module.exports = __webpack_public_path__ + "static/media/PersistentInability.21796fbe.png";